import { useQueries, useQueryClient } from "@tanstack/react-query";

import { getFootprintingBeefFeedProduction, getFootprintingBeefFeedProductionAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_BEEF_FEED_PRODUCTION } from "consts";

export const useGetFootprintingBeefFeedProductions = (feedInformationIds: string[] = []) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useQueries(
    {
      queries: feedInformationIds.map((feedInformationId) => ({
        queryKey: [FOOTPRINTING_BEEF_FEED_PRODUCTION, feedInformationId, isAdmin],
        queryFn: () => (isAdmin ? getFootprintingBeefFeedProductionAdmin(feedInformationId) : getFootprintingBeefFeedProduction(feedInformationId)),
        enabled: !!feedInformationId,
        staleTime: 0,
        gcTime: 0,
      })),
    },
    queryClient
  );
};
